/**
 * Toast notification utilities
 * Centralized error and success toast helpers
 */

import toast from 'react-hot-toast';
import { getApiErrorMessage } from '../lib/api';

/**
 * Show an error toast notification
 * @param error - Error object, string, or unknown error
 * @param defaultMessage - Default message if error cannot be extracted
 */
export const showErrorToast = (error: unknown, defaultMessage = 'An error occurred'): void => {
  const message = error instanceof Error 
    ? error.message 
    : typeof error === 'string' 
    ? error 
    : getApiErrorMessage(error) || defaultMessage;
  
  toast.error(message);
};

/**
 * Show a success toast notification
 * @param message - Success message to display
 */
export const showSuccessToast = (message: string): void => {
  toast.success(message);
};

/**
 * Show an info toast notification
 * @param message - Info message to display
 */
export const showInfoToast = (message: string): void => {
  toast(message, {
    icon: 'ℹ️',
  });
};

